export default __webpack_public_path__ + "static/media/folder-image.a545dd73.png";